import { render, staticRenderFns } from "./initPage.vue?vue&type=template&id=1fae3de2&scoped=true"
import script from "./initPage.vue?vue&type=script&lang=js"
export * from "./initPage.vue?vue&type=script&lang=js"
import style0 from "./initPage.vue?vue&type=style&index=0&id=1fae3de2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fae3de2",
  null
  
)

export default component.exports